export const DATE_FORMAT = {
  MMDDYYYY: "MM/DD/YYYY",
  YYYYMMDD: "YYYY/MM/DD",
};

export const dateFormatOptions = [
  { value: DATE_FORMAT.MMDDYYYY, label: DATE_FORMAT.MMDDYYYY },
  { value: DATE_FORMAT.YYYYMMDD, label: DATE_FORMAT.YYYYMMDD },
];